const DAY_GUESS_SIGN_ROUTES = [
  'simulationtradetemp$dayguesstoday',
  'simulationtradetemp$dayguesspointsbalance',
  'simulationtradetemp$dayguessrecordstat',
  'simulationtradetemp$dayguessrecordlist',
  'simulationtradetemp$dayguessbet'
]

function safeString(value) {
  if (value === undefined || value === null) return ''
  return String(value)
}

function rotateLeft(value, shift) {
  return (value << shift) | (value >>> (32 - shift))
}

function addUnsigned(left, right) {
  const leftHigh = left & 0x80000000
  const rightHigh = right & 0x80000000
  const leftLow = left & 0x40000000
  const rightLow = right & 0x40000000
  const result = (left & 0x3fffffff) + (right & 0x3fffffff)

  if (leftLow & rightLow) return result ^ 0x80000000 ^ leftHigh ^ rightHigh
  if (leftLow | rightLow) {
    if (result & 0x40000000) return result ^ 0xc0000000 ^ leftHigh ^ rightHigh
    return result ^ 0x40000000 ^ leftHigh ^ rightHigh
  }
  return result ^ leftHigh ^ rightHigh
}

function md5Cycle(func, a, b, c, d, x, s, ac) {
  a = addUnsigned(a, addUnsigned(addUnsigned(func(b, c, d), x), ac))
  return addUnsigned(rotateLeft(a, s), b)
}

function f(x, y, z) {
  return (x & y) | (~x & z)
}

function g(x, y, z) {
  return (x & z) | (y & ~z)
}

function h(x, y, z) {
  return x ^ y ^ z
}

function i(x, y, z) {
  return y ^ (x | ~z)
}

function convertToWordArray(text) {
  const length = text.length
  const wordCount = (((length + 8) - ((length + 8) % 64)) / 64 + 1) * 16
  const words = new Array(wordCount - 1)
  let bytePosition = 0
  let byteCount = 0

  while (byteCount < length) {
    const wordPosition = (byteCount - (byteCount % 4)) / 4
    bytePosition = (byteCount % 4) * 8
    words[wordPosition] = words[wordPosition] | (text.charCodeAt(byteCount) << bytePosition)
    byteCount++
  }

  const wordPosition = (byteCount - (byteCount % 4)) / 4
  bytePosition = (byteCount % 4) * 8
  words[wordPosition] = words[wordPosition] | (0x80 << bytePosition)
  words[wordCount - 2] = length << 3
  words[wordCount - 1] = length >>> 29

  return words
}

function wordToHex(value) {
  let hex = ''

  for (let count = 0; count <= 3; count++) {
    const byte = (value >>> (count * 8)) & 255
    hex += `0${byte.toString(16)}`.slice(-2)
  }

  return hex
}

export function md5(value) {
  const x = convertToWordArray(unescape(encodeURIComponent(safeString(value))))
  let a = 0x67452301
  let b = 0xefcdab89
  let c = 0x98badcfe
  let d = 0x10325476

  for (let k = 0; k < x.length; k += 16) {
    const aa = a
    const bb = b
    const cc = c
    const dd = d

    a = md5Cycle(f, a, b, c, d, x[k + 0], 7, 0xd76aa478)
    d = md5Cycle(f, d, a, b, c, x[k + 1], 12, 0xe8c7b756)
    c = md5Cycle(f, c, d, a, b, x[k + 2], 17, 0x242070db)
    b = md5Cycle(f, b, c, d, a, x[k + 3], 22, 0xc1bdceee)
    a = md5Cycle(f, a, b, c, d, x[k + 4], 7, 0xf57c0faf)
    d = md5Cycle(f, d, a, b, c, x[k + 5], 12, 0x4787c62a)
    c = md5Cycle(f, c, d, a, b, x[k + 6], 17, 0xa8304613)
    b = md5Cycle(f, b, c, d, a, x[k + 7], 22, 0xfd469501)
    a = md5Cycle(f, a, b, c, d, x[k + 8], 7, 0x698098d8)
    d = md5Cycle(f, d, a, b, c, x[k + 9], 12, 0x8b44f7af)
    c = md5Cycle(f, c, d, a, b, x[k + 10], 17, 0xffff5bb1)
    b = md5Cycle(f, b, c, d, a, x[k + 11], 22, 0x895cd7be)
    a = md5Cycle(f, a, b, c, d, x[k + 12], 7, 0x6b901122)
    d = md5Cycle(f, d, a, b, c, x[k + 13], 12, 0xfd987193)
    c = md5Cycle(f, c, d, a, b, x[k + 14], 17, 0xa679438e)
    b = md5Cycle(f, b, c, d, a, x[k + 15], 22, 0x49b40821)

    a = md5Cycle(g, a, b, c, d, x[k + 1], 5, 0xf61e2562)
    d = md5Cycle(g, d, a, b, c, x[k + 6], 9, 0xc040b340)
    c = md5Cycle(g, c, d, a, b, x[k + 11], 14, 0x265e5a51)
    b = md5Cycle(g, b, c, d, a, x[k + 0], 20, 0xe9b6c7aa)
    a = md5Cycle(g, a, b, c, d, x[k + 5], 5, 0xd62f105d)
    d = md5Cycle(g, d, a, b, c, x[k + 10], 9, 0x02441453)
    c = md5Cycle(g, c, d, a, b, x[k + 15], 14, 0xd8a1e681)
    b = md5Cycle(g, b, c, d, a, x[k + 4], 20, 0xe7d3fbc8)
    a = md5Cycle(g, a, b, c, d, x[k + 9], 5, 0x21e1cde6)
    d = md5Cycle(g, d, a, b, c, x[k + 14], 9, 0xc33707d6)
    c = md5Cycle(g, c, d, a, b, x[k + 3], 14, 0xf4d50d87)
    b = md5Cycle(g, b, c, d, a, x[k + 8], 20, 0x455a14ed)
    a = md5Cycle(g, a, b, c, d, x[k + 13], 5, 0xa9e3e905)
    d = md5Cycle(g, d, a, b, c, x[k + 2], 9, 0xfcefa3f8)
    c = md5Cycle(g, c, d, a, b, x[k + 7], 14, 0x676f02d9)
    b = md5Cycle(g, b, c, d, a, x[k + 12], 20, 0x8d2a4c8a)

    a = md5Cycle(h, a, b, c, d, x[k + 5], 4, 0xfffa3942)
    d = md5Cycle(h, d, a, b, c, x[k + 8], 11, 0x8771f681)
    c = md5Cycle(h, c, d, a, b, x[k + 11], 16, 0x6d9d6122)
    b = md5Cycle(h, b, c, d, a, x[k + 14], 23, 0xfde5380c)
    a = md5Cycle(h, a, b, c, d, x[k + 1], 4, 0xa4beea44)
    d = md5Cycle(h, d, a, b, c, x[k + 4], 11, 0x4bdecfa9)
    c = md5Cycle(h, c, d, a, b, x[k + 7], 16, 0xf6bb4b60)
    b = md5Cycle(h, b, c, d, a, x[k + 10], 23, 0xbebfbc70)
    a = md5Cycle(h, a, b, c, d, x[k + 13], 4, 0x289b7ec6)
    d = md5Cycle(h, d, a, b, c, x[k + 0], 11, 0xeaa127fa)
    c = md5Cycle(h, c, d, a, b, x[k + 3], 16, 0xd4ef3085)
    b = md5Cycle(h, b, c, d, a, x[k + 6], 23, 0x04881d05)
    a = md5Cycle(h, a, b, c, d, x[k + 9], 4, 0xd9d4d039)
    d = md5Cycle(h, d, a, b, c, x[k + 12], 11, 0xe6db99e5)
    c = md5Cycle(h, c, d, a, b, x[k + 15], 16, 0x1fa27cf8)
    b = md5Cycle(h, b, c, d, a, x[k + 2], 23, 0xc4ac5665)

    a = md5Cycle(i, a, b, c, d, x[k + 0], 6, 0xf4292244)
    d = md5Cycle(i, d, a, b, c, x[k + 7], 10, 0x432aff97)
    c = md5Cycle(i, c, d, a, b, x[k + 14], 15, 0xab9423a7)
    b = md5Cycle(i, b, c, d, a, x[k + 5], 21, 0xfc93a039)
    a = md5Cycle(i, a, b, c, d, x[k + 12], 6, 0x655b59c3)
    d = md5Cycle(i, d, a, b, c, x[k + 3], 10, 0x8f0ccc92)
    c = md5Cycle(i, c, d, a, b, x[k + 10], 15, 0xffeff47d)
    b = md5Cycle(i, b, c, d, a, x[k + 1], 21, 0x85845dd1)
    a = md5Cycle(i, a, b, c, d, x[k + 8], 6, 0x6fa87e4f)
    d = md5Cycle(i, d, a, b, c, x[k + 15], 10, 0xfe2ce6e0)
    c = md5Cycle(i, c, d, a, b, x[k + 6], 15, 0xa3014314)
    b = md5Cycle(i, b, c, d, a, x[k + 13], 21, 0x4e0811a1)
    a = md5Cycle(i, a, b, c, d, x[k + 4], 6, 0xf7537e82)
    d = md5Cycle(i, d, a, b, c, x[k + 11], 10, 0xbd3af235)
    c = md5Cycle(i, c, d, a, b, x[k + 2], 15, 0x2ad7d2bb)
    b = md5Cycle(i, b, c, d, a, x[k + 9], 21, 0xeb86d391)

    a = addUnsigned(a, aa)
    b = addUnsigned(b, bb)
    c = addUnsigned(c, cc)
    d = addUnsigned(d, dd)
  }

  return `${wordToHex(a)}${wordToHex(b)}${wordToHex(c)}${wordToHex(d)}`.toLowerCase()
}

export function createXSign(basicData, userId) {
  const basicDataText = safeString(basicData)
  const userIdText = safeString(userId)

  if (!basicDataText) return ''

  return md5(`${userIdText}${basicDataText}`)
}

export function shouldAddTradeHeaders(headers = {}) {
  const routes = safeString(headers.Routes || headers.Route)
  if (!routes) return false
  return DAY_GUESS_SIGN_ROUTES.some((route) => routes.split(',').includes(route))
}
